module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1532-2f2265c817e826aff0eee330fd3697a8.png";